import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from "react-i18next";
import SignalRService from "src/controllers/SignalRService";
import DataGrid, { Paging, Column, Pager, ColumnFixing } from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import { changeJanusStatus } from '../../redux/parametersSlice';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import ChatsService from 'src/controllers/ChatController';
import { setConverastionBookId } from 'src/redux/interactionsSlice';
import { selectContact } from 'src/redux/agentSlice';
import Toastr from '../utils/toastr';

function waitForRegisterContactsList() {
    return new Promise((resolve) => {
        SignalRService.registerContactsList(e => {
            resolve(e);
        });
    });
}

function buildFilter(data) {
    let ret = "";
    if (Array.isArray(data[0])) {
        data.forEach(d => {
            let queryPart = buildFilter(d)
            if ((Array.isArray(d) && ret.indexOf(d[0]) === -1) || !Array.isArray(d))
                ret += queryPart;
        });

    } else {
        if (Array.isArray(data)) {

            //!TRAMPA JUSANIANA
            let tokens = data[0].split("_");
            let typeId = parseInt(tokens[2]);

            if ([7, 8, 17, 31].indexOf(typeId) > -1) {
                if (ret.indexOf(data[0]) === -1)
                    ret += ` (${data[0]} ge ${data[2]}) `;
            }
            else {
                ret += ` (${data[0]} eq ${data[2]}) `;
            }

        } else {
            ret = data
        }
    }
    return ret
}


class FidelityContactsSelection extends Component {

    constructor(props) {
        super(props);

        this.state = {
            fields: [],
            store: this.createCustomStore(props)
        }

        this.setFields = this.setFields.bind(this);
        this.phoneCell = this.phoneCell.bind(this);
        this.emailCell = this.emailCell.bind(this);
        this.listCell = this.listCell.bind(this);
        this.aassociatedContact = this.aassociatedContact.bind(this);
        this.toastrRef = React.createRef();
        this.dataGridCntSelRef = createRef();
        SignalRService.registerAddressBookFields(this.setFields);
    }
    componentDidMount() {
        SignalRService.getAddressBookFields({ userId: this.props.userId, extension: this.props.extension }, (error) => { });
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.contacts !== null && JSON.stringify(this.props.contacts) !== JSON.stringify(prevProps.contacts)) {
            this.setState({ store: this.createCustomStore(this.props) });
        }
    }

    createCustomStore = (props) => {
        return new CustomStore({
            key: 'contactId',
            async load(loadOptions) {
                let sort = "";
                let dxFitlers = loadOptions.filter ? loadOptions.filter : "";
                let filter = buildFilter(dxFitlers);

                if (filter.endsWith("and"))
                    filter = filter.slice(0, -3);

                if (loadOptions.sort && loadOptions.sort.length > 0)
                    sort = loadOptions.sort[0].selector + " " + (loadOptions.sort[0].desc ? "desc" : "");

                let cnts = [];
                let cntsSelection = props.contacts
                cntsSelection.forEach(cnt => {

                    cnts.push(cnt.contactId);
                });

                if (cnts.length > 0) {

                    filter = "bookIds eq '" + cnts.join(',') + "'";
                }

                let filters = {
                    "extension": localStorage.getItem("faExtension"),
                    "userId": parseInt(localStorage.getItem("faUserId")),
                    "skip": loadOptions.skip,
                    "take": loadOptions.take,
                    "sort": sort,
                    "filters": filter
                }

                const registerPromise = waitForRegisterContactsList();
                SignalRService.getContacts(filters);
                const result = await registerPromise;

                try {
                    let data = JSON.parse(result);
                    let contacts = [];

                    data.result.forEach(c => {
                        let contact = {
                            contactId: c.ContactId
                        };

                        c.Fields.forEach(f => {
                            let id = "field_" + f.FieldId;

                            contact[id] = "";

                            if ([1, 2, 9, 10, 13, 14, 15, 20, 21, 32, 33, 34].indexOf(f.TypeId) > -1)
                                contact[`field_${f.FieldId}_${f.TypeId}`] = f.StringValue;

                            if (f.TypeId === 3)
                                contact[`field_${f.FieldId}_${f.TypeId}`] = f.IntValue;

                            if (f.TypeId === 4)
                                contact[`field_${f.FieldId}_${f.TypeId}`] = f.FloatValue;

                            if (f.TypeId === 5)
                                contact[`field_${f.FieldId}_${f.TypeId}`] = f.BoolValue;

                            if ([7, 17, 31].indexOf(f.TypeId) > -1)
                                contact[`field_${f.FieldId}_${f.TypeId}`] = f.DateValue;

                            if (8 === f.TypeId && f.DateValue)
                                contact[`field_${f.FieldId}_${f.TypeId}`] = new Date(f.DateValue).toLocaleTimeString();

                            if ([11, 12].indexOf(f.TypeId) > -1)
                                contact[`field_${f.FieldId}_${f.TypeId}`] = f.TextValue;
                        });

                        contacts.push(contact);

                    });
                    console.log(contacts);
                    return {
                        data: contacts,
                        totalCount: data.count
                    };
                } catch (err) {
                    throw new Error('Data Loading Error');
                }
            },
        })
    }


    setFields = data => {

        let fields = [{
            fieldId: "contactId",
            name: "contactId",
            type: "number",
            values: null
        }];
        let pages = JSON.parse(data);

        pages.forEach(page => {

            page.Fields.forEach(v => {
                let type = "string";

                if (v.Type === "BOOLEAN")
                    type = "boolean";

                if (v.Type === "DATE")
                    type = "date";

                if (v.Type === "DATETIME")
                    type = "datetime";

                if (v.Type === "TIME")
                    type = "time";

                if (v.Type === "NUMERIC" || v.Type === "FLOAT")
                    type = "number";

                fields.push({
                    fieldId: `field_${v.FieldId}_${v.TypeId}`,
                    name: v.Name,
                    type: type,
                    typeId: v.TypeId,
                    values: v.Values
                });
            });

        });

        this.setState({ fields: fields });
    }

    phoneCell = dataCell => {
        return (
            (dataCell.value) &&
            <a className={""} href="/#" onClick={(e) => {
                e.preventDefault();
                this.props.changeJanusStatus("makeCall");
                SignalRService.makeCall({
                    "extension": this.props.extension,
                    "userId": this.props.userId,
                    "called": dataCell.value
                });
            }}>{dataCell.value}</a>
        )
    }

    emailCell = dataCell => {
        return (
            (dataCell.value) &&
            <a className={""} href={`mailto:${dataCell.value}`}>{dataCell.value}</a>
        )
    }

    listCell = dataCell => {
        return dataCell.text || "";
    }

    aassociatedContact(dataCell) {

        this.props.setSearchContacts(false);
        if (this.props.mode === 'call') {
            SignalRService.associatedContact({
                "extension": this.props.extension,
                "userId": this.props.userId,
                "contactId": dataCell.data.contactId
            });
            this.props.selectContact(dataCell.data.contactId);

        } else {

            ChatsService.setConverastionBookId({
                guid: this.props.interaction.guid,
                contactId: dataCell.data.contactId
            }, res => {
                if (res !== "ok") {

                    this.toastrRef.current.setType("error");
                    this.toastrRef.current.setMessage(this.props.t(res));
                    this.toastrRef.current.show();
                } else {
                    this.props.setConverastionBookId(dataCell.data.contactId);
                    this.toastrRef.current.setType("success");
                    this.toastrRef.current.setMessage(this.props.t("wassavedsuccessfully"));
                    this.toastrRef.current.show();
                }
            });
        }
    }

    editCell = dataCell => {
        return (
            <Button variant={""} size='sm' className={"text-primary"} onClick={(e) => {
                this.aassociatedContact(dataCell);
            }}>
                <FontAwesomeIcon icon={duotone("pen-to-square")} />
            </Button>
        );
    }

    render() {
        return (
            <div style={{ position: "relative", right: "10px" }}>
                {
                    //(this.state.fields != null && this.state.fields.length > 0) &&
                    <DataGrid
                        dataSource={this.state.store}
                        id={`fidelitycontactsselectiontable_${this.props.mode}`}
                        noDataText=""
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        height={"65vh"}
                        width={"100%"}
                        ref={this.dataGridCntSelRef}
                        allowColumnResizing={true}
                    >
                        <Column caption={""} cellRender={this.editCell} width={60} cssClass={"align-middle"} fixed={true} fixedPosition="right" />
                        {this.state.fields.map(x => {
                            let column = <Column dataField={x.fieldId} cssClass={"align-middle"} dataType={x.type} caption={x.name} width={150} visible={x.fieldId !== "contactId"} />

                            if (x.typeId === 1)
                                column = <Column cellRender={this.phoneCell} dataField={x.fieldId} cssClass={"align-middle"} dataType={x.type} caption={x.name} width={150} visible={x.fieldId !== "contactId"} />

                            if (x.typeId === 10)
                                column = <Column cellRender={this.emailCell} dataField={x.fieldId} cssClass={"align-middle"} dataType={x.type} caption={x.name} width={150} visible={x.fieldId !== "contactId"} />

                            if (x.typeId === 9)
                                column = <Column cellRender={this.listCell} dataField={x.fieldId} cssClass={"align-middle"} dataType={x.type} caption={x.name} width={150} visible={x.fieldId !== "contactId"} />

                            return column;
                        })
                        }
                        <ColumnFixing enabled={true} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={[5, 9, 12, 15]}
                            showInfo={true}
                            showNavigationButtons={true}
                            infoText={this.props.t("pager")}
                        />
                        <Paging defaultPageSize={12} />
                    </DataGrid>
                }
                <Toastr ref={this.toastrRef} />
            </div>)
    }
}

const mapStateToProps = (state) => {
    return {
        extension: state.agent.extension,
        userId: state.agent.userId,
        interaction: state.interaction.current
    };
};

export default compose(connect(mapStateToProps, { changeJanusStatus, setConverastionBookId, selectContact }), withTranslation())(FidelityContactsSelection);
